<template>
    <div class="login-page">
        <van-nav-bar
            placeholder
            fixed
            left-arrow
            :border="false"
            class="login-nav"
            @click-left="$router.go(-1)">
            <template #left>
                <van-icon name="arrow-left" size="25" color="#fff"/>
            </template>
        </van-nav-bar>
        <div class="login-content">
            <div class="login-logo-wrap">
                <div class="login-logo">
                    <svg viewBox="0 0 40 40" class="logo-icon" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style="stop-color:#E50914"/>
                                <stop offset="100%" style="stop-color:#B20710"/>
                            </linearGradient>
                        </defs>
                        <rect width="40" height="40" rx="8" fill="url(#logoGrad)"/>
                        <path d="M16 12v4h-2v-6h6v2h-4zM16 28v-8h2v8h-2z" fill="#fff" opacity="0.9"/>
                        <circle cx="24" cy="20" r="4" fill="none" stroke="#fff" stroke-width="1.5" opacity="0.9"/>
                    </svg>
                </div>
                <div class="login-app-name">NetShort</div>
            </div>

            <div class="login-buttons">
                <button type="button" class="login-btn login-btn-facebook" @click="signInFacebook">
                    <svg class="btn-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path fill="currentColor" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                    <span>{{ $t('common.login_facebook') }}</span>
                </button>
                <button type="button" class="login-btn login-btn-google" @click="signInGoogle">
                    <svg class="btn-icon btn-icon-google" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                    </svg>
                    <span>{{ $t('common.login_google') }}</span>
                </button>

                <div class="login-divider">
                    <span class="login-divider-line"></span>
                    <span class="login-divider-text">{{ $t('common.login_or') }}</span>
                    <span class="login-divider-line"></span>
                </div>

                <button type="button" class="login-btn login-btn-email" @click="continueWithEmail">
                    {{ $t('common.login_continue_email') }}
                </button>
            </div>

            <div class="login-agreement">
                <span class="login-agreement-text">{{ $t('common.login_agreement_prefix') }}</span>
                <span class="login-agreement-link" @click="userClick">{{ $t('common.login_user_agreement') }}</span>
                <span class="login-agreement-text">{{ $t('common.login_and') }}</span>
                <span class="login-agreement-link" @click="privacyClick">{{ $t('common.login_privacy') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            userClick() {
                this.$router.push({ path: '/agreement' });
            },
            privacyClick() {
                this.$router.push({ path: '/privacy' });
            },
            signInFacebook() {
                this.$toast(this.$t('common.login_facebook'));
                // TODO: 接入 Facebook 登录 SDK
            },
            signInGoogle() {
                this.$toast(this.$t('common.login_google'));
                // TODO: 接入 Google 登录 SDK
            },
            continueWithEmail() {
                this.$router.replace({ path: '/logincode' });
            },
        }
    };
</script>

<style scoped>
    .login-page {
        min-height: 100vh;
        background: linear-gradient(180deg, #1a1a2e 0%, #16213e 50%, #0f0f1a 100%);
        position: relative;
    }

    .login-nav {
        background: transparent !important;
    }

    .login-content {
        padding: 120px 40px 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        min-height: 100vh;
    }

    .login-logo-wrap {
        margin-bottom: 60px;
        text-align: center;
    }

    .login-logo {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;
    }

    .logo-icon {
        width: 80px;
        height: 80px;
    }

    .login-app-name {
        font-size: 32px;
        font-weight: 600;
        color: #fff;
        letter-spacing: 0.02em;
    }

    .login-buttons {
        width: 100%;
        max-width: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }

    .login-btn {
        width: 100%;
        height: 52px;
        border: none;
        border-radius: 26px;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        cursor: pointer;
        transition: opacity 0.2s;
    }

    .login-btn:active {
        opacity: 0.9;
    }

    .login-btn-facebook {
        background: #1877F2;
    }

    .login-btn-google {
        background: #4a4a4a;
        color: #fff;
    }

    .btn-icon {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
    }

    .btn-icon-google {
        width: 22px;
        height: 22px;
    }

    .login-btn-email {
        background: linear-gradient(90deg, #E50914 0%, #B20710 100%);
        margin-top: 8px;
    }

    .login-divider {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 16px;
        margin: 12px 0 8px;
    }

    .login-divider-line {
        flex: 1;
        height: 1px;
        background: rgba(255, 255, 255, 0.3);
    }

    .login-divider-text {
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
    }

    .login-agreement {
        margin-top: auto;
        padding-top: 40px;
        text-align: center;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.7);
        line-height: 1.5;
    }

    .login-agreement-link {
        color: #fff;
        text-decoration: underline;
        cursor: pointer;
    }

    .login-agreement-link:active {
        opacity: 0.8;
    }
</style>
